import type { CSSProperties } from 'react'

/**
 * Streifen-Hintergrund für PENDING-Abwesenheiten (Antrag noch nicht
 * genehmigt): permanent sichtbar statt hover-only (Touch-first) und klar
 * von der satten Fläche genehmigter Abwesenheiten unterscheidbar.
 * Akzeptiert JEDE CSS-Farbe (Hex aus den Kalender-ABSENCE_COLOR-Maps wie
 * rgba-Strings aus team-planning) — deshalb color-mix statt Hex-Konkatenation.
 */
export function pendingAbsenceStyle(color: string): CSSProperties {
  const soft = `color-mix(in srgb, ${color} 14%, transparent)`
  const stripe = `color-mix(in srgb, ${color} 28%, transparent)`
  return {
    backgroundImage: `repeating-linear-gradient(135deg, ${soft} 0 6px, ${stripe} 6px 12px)`,
  }
}
